import axios from "./config";

const SCHEMA = "/tickets";

export function GetTicketsTypes() {
  return axios.get(`${SCHEMA}/types`);
}
